import React from 'react';
import { useTableDetail } from "../../../../../common/API/hooks";
import SelectFilter from "../../../../../common/components/SelectComponent";
import { getSelectedOption } from "../../../../../common/utils";
import { components } from "react-select";
import ColumnOption from "./ColumnOption";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from '@mui/material/CircularProgress';

export default function ColumnSelector({onChangeColumns, columns, tableId, maxValueCount, columnPrimaryKey,showMultiValueComponent, label}) {
    const {data: columnList, isLoading: isLoadingFilters} = useTableDetail(tableId, {
        enabled: !!tableId
    })

    if (!columnPrimaryKey) {
        columnPrimaryKey = 'name'
    }
    
    const options = columnList?.columns.map(columnRow => {
        return {
            label: columnRow.name,
            value: columnRow[columnPrimaryKey],
            json_type: columnRow.json_type
        }
     })

    const MoreSelectedItems = ({ items }) => {
        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Henry Sans",
            fontSize: "11px",
            padding: "2px",
            order: 99,
            fontWeight: '500'
        };
        const title = items.join(",");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;
        
        return (
            <div style={style} title={title}>
            {label}
            </div>
        );
    };

    const isMulti = maxValueCount > 1 || !maxValueCount

    const components = {
        Option: ColumnOption
    }
 
    return <Grid item md={12} marginBottom={2}>
        <Autocomplete
            multiple
            limitTags={3}
            options={options|| []}
            getOptionLabel={(option) => option?.label || ""}
            value={getSelectedOption(columns, options)}
            onChange={(event,e)=> {
                if (isMulti) {
                    onChangeColumns(e ? e.map(option => option.value) : null)
                } else {
                    onChangeColumns(e ? [e.value] : null)
                }
            }}
            id="column_options" size="small"
            disabled={isLoadingFilters || !tableId}
            loading={isLoadingFilters}
            sx={{ width: "100%" }}
            // TODO: RENDER OPTION, COLUMNOPTION
            renderInput={(params) => <TextField {...params} label={label}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                    <React.Fragment>
                        {isLoadingFilters ? <CircularProgress color="secondary" size={20} /> : null}
                        {params.InputProps.endAdornment}
                    </React.Fragment>
                    ),
                }}
                required/>
            }
        />
    </Grid>
}